import awaitWrap from '../../../../procedures/await-wrap';
import httpWrap from '../../../../procedures/http-wrap';
import action from '../../../abstract/action';


const handle = async (
  {
    $vs,
    item,
    reloadList,
    model: {
      api: {
        softDelete,
      },
    },
  },
) => {

  $vs.dialog({
    accept: async () => await httpWrap({
      $vs,
      action: softDelete,
      success: { text: 'Zestaw został usunięty' },
      onSuccess: reloadList,
    })(item),
    type: 'confirm',
    color: 'primary',
    title: 'Usunięcie zestawu',
    text: await awaitWrap(({ id }) => `Czy na pewno chcesz usunąć zestaw?`)(item),
    acceptText: 'Usuń',
    cancelText: 'Wróć',
  });
};

export default action({
  label: 'Usuń',
  icon: 'TrashIcon',
  main: () => false,
  handle,
  disabled: (item) => isDisabled(item),
  tooltip: {
    isActive: (item) => isDisabled(item),
    text: 'Nie można usunąć zestawu który został wysłany',
  },
});

function isDisabled(item) {
  if (item?.sent_at === null) {
    return false;
  }

  return item?.status === 'Przesyłka przyjęta do ZUS' || item?.status === 'Przesyłka przyjęta do kontroli' || (item.task_index_package_in_zus && !item.index_package_in_zus);
}
